// extracted by mini-css-extract-plugin
export default {"container":"header_container__7HyC8","titleWrapper":"header_titleWrapper__N8krg"};